import { render, staticRenderFns } from "./EquipmentLicensesPatents.vue?vue&type=template&id=0fc54578&scoped=true"
import script from "./EquipmentLicensesPatents.vue?vue&type=script&lang=js"
export * from "./EquipmentLicensesPatents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc54578",
  null
  
)

export default component.exports